import { ExternalCallTypeApiModel } from './ExternalCallTypeApiModel';

export class ExternalCallTypesApiModel {
  public Items: Array<ExternalCallTypeApiModel>;

  public deserialize(data: Object): ExternalCallTypesApiModel {
    Object.assign(this, data);
    this.Items = this.Items.map((item) => new ExternalCallTypeApiModel().deserialize(item));

    return this;
  }
}
